import React, { memo } from 'react';

import { CardMedia, IconButton } from '@mui/material';

import { ReactComponent as CloseContainedIcon } from 'assets/icons/CloseContainedIcon.svg';
import noImageSrc from 'assets/images/no-image.png';

import { IThumbnailViewProps } from './types';

import styles from './ThumbnailView.module.scss';

const ThumbnailView: React.FC<IThumbnailViewProps> = memo((props) => {
  const { value, onDelete } = props;

  const handleImageClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
  };

  const handleDelete: React.MouseEventHandler | undefined = onDelete
    ? (event) => {
        event.stopPropagation();
        onDelete();
      }
    : undefined;

  return (
    <div className={styles.thumbnailContainer}>
      <CardMedia
        component="img"
        image={value.url ?? noImageSrc}
        alt={value.filename}
        className={styles.thumbnailImage}
        onClick={handleImageClick}
      />

      <IconButton className={styles.removeButton} size={'small'} onClick={handleDelete}>
        <CloseContainedIcon />
      </IconButton>
    </div>
  );
});

export default ThumbnailView;
